import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalizationService } from '@core/services';

@Component({
  selector: 'bz-towns-list',
  templateUrl: './bz-towns-list.component.html',
  styleUrls: ['./bz-towns-list.component.sass']
})
export class BzTownsListComponent {
  @Input() public moreTownText: string = '';
  @Input() public moreTowns: { name: string, nameEn: string }[] = [];
  @Input() public searchTarget: string = '';

  @Output() public onResetScroll: EventEmitter<void> = new EventEmitter();

  trackByName = (_: unknown, item: { nameEn: string }) => item.nameEn;

  public get routerLinkToPreparat(): string {
    return this.localizationService.getRouterLinkApp('preparat');
  }

  constructor(
    private readonly localizationService: LocalizationService
  ) { }

  public resetScroll(): void {
    this.onResetScroll.emit();
  }
}
